import { useUser } from '@clerk/react';
import { GtqyClientProvider, SessionProvider } from '@vrplatform/data';
import type { ReactNode } from 'react';
import { FullPageLoadingIndicator } from '../components';
import { OwnerPortalAccessDenied } from '../views/owner-portal/OwnerPortalAccessDenied';

type AppRouterProps = {
  children: ReactNode;
};

export function DBProvider(props: AppRouterProps) {
  const { user } = useUser();

  return (
    <GtqyClientProvider>
      <SessionProvider
        renderAccessDenied={({ portalName, signOut }) => (
          <OwnerPortalAccessDenied
            portalName={portalName}
            email={user?.primaryEmailAddress?.emailAddress}
            onSignOut={signOut}
          />
        )}
        renderPortalSwitch={({ message }) => (
          <FullPageLoadingIndicator message={message} showSignOut={false} />
        )}
      >
        {props.children}
      </SessionProvider>
    </GtqyClientProvider>
  );
}
